// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2T1m3","info":"Note_info__3MWGJ","note":"Note_note__f8Lpb","actions":"Note_actions__3nvaT"};